import {useStores} from "../../Hooks";
import {Button} from "@mui/material";
import React, {useEffect} from "react";
import sharedUtils, {
    DEVICE_LOGIN_DOMAIN, HP_DEVICE_LOGIN_DOMAIN
} from '../../serverClientShared/sharedUtils';
import ConditionalComponent from "../Shared/ConditionalComponent";
import {
    SelectDomainNameStep,
    LoginFlow, SelectDomainStep, ConfirmationStep, EnterDeviceLoginCodeStep, PasswordStep, SSOStep, EmailStep
} from "../OnBoarding/SharedSteps";
import {observer} from "mobx-react";
import Cookies from "js-cookie";
import Settings from "../../settings.json";
import frontlineLogo from "../../assets/img/frontlineio-logo.svg";
import hpXRLogo from "../../assets/img/hp-xRServices-logo.png";
import ReplayIcon from '@mui/icons-material/Replay';
import './deviceLogin.scss'

const hpSteps = [
    {
        label: "enterCode",
        component: EnterDeviceLoginCodeStep
    },
    {
        label: "signIn",
        component: SSOStep
    },
    {
        label: "selectWorkspace",
        component: SelectDomainStep
    },
    {
        label: "workspaceName",
        component: SelectDomainNameStep
    },
    {
        label: "confirmation",
        component: ConfirmationStep
    }
]

const regularSteps = [

    {
        label: "enterCode",
        component: EnterDeviceLoginCodeStep
    },
    {
        label: "userDetails",
        component: EmailStep,
    },
    {
        label: "userDetails",
        component: PasswordStep
    },
    {
        label: "selectWorkspace",
        component: SelectDomainStep
    },
    {
        label: "workspaceName",
        component: SelectDomainNameStep
    },
    {
        label: "confirmation",
        component: ConfirmationStep
    }
];


const DeviceLogin = observer(() => {
    const {generalStore} = useStores();
    const {
        workspace, deviceLoginDone
    } = generalStore;
    const isHpBranded = !!generalStore.workspaceIsHP;


    useEffect(() => {
        if (workspace !== DEVICE_LOGIN_DOMAIN && workspace !== HP_DEVICE_LOGIN_DOMAIN) {
            let {host, protocol} = window.location;
            if (!workspace) {
                host = `${sharedUtils.LOGIN_DOMAIN}.${host}`;
            }
            window.location.href = `${protocol}//${host.replace(`${workspace}.`, `${sharedUtils.LOGIN_DOMAIN}.`)}/login`;
            return;
        }
        Cookies.remove(Settings.tokenCookieName);
        generalStore.userDetails = {};
        generalStore.showHelpDesk = false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={`on-boarding-container${isHpBranded ? ' hp-branded' : ''}`}>
            <img src={isHpBranded ? hpXRLogo : frontlineLogo} alt='' className='logo'/>
            {/*<LanguageMenu onBoarding={true} isHpBranded={isHpBranded}/>*/}
            <ConditionalComponent if={!deviceLoginDone}>
                <LoginFlow isDeviceLogin={true} isHpBranded={isHpBranded} steps={workspace === HP_DEVICE_LOGIN_DOMAIN ? hpSteps : regularSteps} withoutStepper={workspace === HP_DEVICE_LOGIN_DOMAIN}/>
            </ConditionalComponent>
            <ConditionalComponent if={!!deviceLoginDone}>
                <div className={`finish-container${isHpBranded ? ' hp-branded' : ''}`}>
                    <div className='finish-container-title'>
                        {generalStore.translate('deviceLoginCompleted')}
                    </div>
                    <div className=''>
                        {generalStore.translate('yourDeviceShouldBeConnectedSoon')}
                    </div>
                    <Button className='primary-button' variant='outlined'
                            onClick={() => {
                                generalStore.deviceLoginDone = false;
                                generalStore.deviceLoginCode = '';
                                generalStore.signInData = {};
                                if (isHpBranded) {
                                    let {host, protocol} = window.location;
                                    window.location.href = `${protocol}//${host.replace(`${sharedUtils.HP_LOGIN_DOMAIN}.`, `${sharedUtils.HP_DEVICE_LOGIN_DOMAIN}.`)}/login`;
                                }
                            }}>
                        <ReplayIcon/>{generalStore.translate('startOver')}
                    </Button>
                </div>

            </ConditionalComponent>
        </div>
    )
});
export default DeviceLogin;
